interface Props {
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (next: number) => void;
  ariaLabel?: string;
}

export function Stepper({ value, min = 0, max = 99, step = 1, onChange, ariaLabel }: Props) {
  const clamp = (n: number) => Math.max(min, Math.min(max, n));
  return (
    <div className="stepper">
      <button type="button" onClick={() => onChange(clamp(value - step))} aria-label={`Decrement ${ariaLabel ?? ''}`}>
        −
      </button>
      <input
        type="number"
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={(e) => onChange(clamp(Number(e.target.value)))}
        aria-label={ariaLabel}
      />
      <button type="button" onClick={() => onChange(clamp(value + step))} aria-label={`Increment ${ariaLabel ?? ''}`}>
        +
      </button>
    </div>
  );
}
